import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { StoreManager } from "@/components/admin/StoreManager";
import { useSettings } from "@/lib/settings";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const StoreTab = () => {
  const { settings, refresh } = useSettings();
  const [name, setName] = useState(settings.store_name || "Spirit Store");
  const [saving, setSaving] = useState(false);
  const active = settings.store_active !== false;

  useEffect(() => { setName(settings.store_name || "Spirit Store"); }, [settings.store_name]);

  const saveName = async () => {
    if (!name.trim()) { toast.error("Store name can't be empty."); return; }
    setSaving(true);
    try {
      await api.put("/admin/settings", { store_name: name.trim() });
      refresh();
      toast.success("Store name updated");
    } catch {
      toast.error("Couldn't update. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const toggleActive = async () => {
    try {
      await api.put("/admin/settings", { store_active: !active });
      refresh();
      toast.success(!active ? "Store is now live" : "Store hidden from the site");
    } catch {
      toast.error("Couldn't update. Please try again.");
    }
  };

  return (
    <div data-testid="store-tab">
      <div className="bg-white border border-line p-5 mb-8 grid sm:grid-cols-2 gap-5">
        <div>
          <label className="block text-xs tracking-[0.14em] text-navy/60 font-semibold mb-1.5">STORE NAME</label>
          <div className="flex gap-2">
            <input value={name} onChange={(e) => setName(e.target.value)} data-testid="store-name-setting"
              className="w-full border border-line px-4 py-2.5 text-sm outline-none focus:border-navy" placeholder="Spirit Store" />
            <button onClick={saveName} disabled={saving} data-testid="save-store-name"
              className="bg-ink text-white px-4 flex items-center gap-1.5 text-xs font-bold tracking-[0.1em] hover:bg-navy transition-colors disabled:opacity-60">
              {saving ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} SAVE
            </button>
          </div>
          <p className="text-navy/40 text-[11px] mt-1.5">Shown as the store page title (e.g. "Cheer Spirit Shop").</p>
        </div>
        <div className="flex items-center justify-between border-t sm:border-t-0 sm:border-l border-line sm:pl-5 pt-4 sm:pt-0">
          <div>
            <p className="font-semibold text-sm text-ink">Store live on the site</p>
            <p className="text-navy/50 text-xs mt-0.5">Turn off to hide the store and its nav link while you set up.</p>
          </div>
          <button type="button" role="switch" aria-checked={active} onClick={toggleActive} data-testid="store-active-toggle"
            className={`relative w-14 h-8 rounded-full transition-colors shrink-0 ${active ? "bg-gold" : "bg-navy/25"}`}>
            <span className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow transition-transform ${active ? "translate-x-6" : "translate-x-0"}`} />
          </button>
        </div>
      </div>
      <StoreManager />
    </div>
  );
};
